// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__307Tm","tab":"Tabs_tab__2bOXJ","tabActive":"Tabs_tabActive__2lMlC"};